import { makeStyles } from '@fluentui/react-components';

export const useAppDataBootstrapStyles = makeStyles({
  spinner: {
    height: '100%',
  },
});
